export default __webpack_public_path__ + "static/media/move_to.1d92f446.svg";